"use client";

import React from "react";
import { cn } from "utils";

/**
 * Header 组件 - 基础UI组件
 *
 * @category Basic UI Component
 * @example
 * ```tsx
 * <Header />
 * <Header title="Custom Alert" description="Custom description" icon="heart" />
 * ```
 */
export interface HeaderProps {
  /** 自定义CSS类名 */
  className?: string;
  /** 标题文本 */
  title: string;
  /** 描述文本 */
  description: string;
  /** logo */
  logo?: string;
}

/**
 * Header 组件实现
 */
const AgentHeader: React.FC<HeaderProps> = ({
  className,
  // title = "",
  description = "",
}) => {
  return (
    <div
      className={cn(
        // 布局和间距
        // "flex flex-col gap-2 pb-5",
        // 背景和边框 - 使用项目主题变量
        className,
      )}
    >
      {/* 图标容器 */}
      {/* <div className="flex items-center gap-2"> */}
      {/* <AssetImage src={logo} alt="logo" width={32} height={32} /> */}
      {/* <div className={cn("headline_regular_s", "text-content_primary")}>{title}</div> */}
      {/* </div> */}

      <p className={cn("body_m", "text-content_secondary")}>{description}</p>
    </div>
  );
};

export default AgentHeader;
